import NotFound from "../features/notFound/NotFound";

export default function NotFoundPage() {
  return (
    <div style={{ marginTop: 100 }}>
      <NotFound />
    </div>
  );
}
